import Button from "@adoo-ui/Atom/Button";
import {useIsMobile} from "@hooks/useIsMobile";
import logoAdooBranco from "@images/AdooBranco.png";
import checkMark from "@images/check-mark.png";
import footerBG from "@images/footer-bg.png";
import {Formik} from "formik";
import {useCallback, useEffect, useState} from "react";
import Form from "react-bootstrap/Form";
import InputGroup from "react-bootstrap/InputGroup";
import {useGoogleReCaptcha} from "react-google-recaptcha-v3";
import {useLocation} from "react-router-dom";
import "./Footer.scss";

type ContactMessageType = {
  tokenRecaptcha: string;
  name: string;
  email: string;
  message: string;
};

interface IFooterProps {
  showContactForm: boolean;
  onFormSubmit: (values: ContactMessageType) => Promise<any>;
  enableRecaptcha: boolean;
  isBlackFriday: boolean;
}

const initialValueContactForm = {
  name: "",
  email: "",
  message: "",
  tokenRecaptcha: "",
};

function Footer({
  showContactForm,
  onFormSubmit,
  enableRecaptcha = true,
  isBlackFriday,
}: IFooterProps) {
  const {isMobile} = useIsMobile();

  const {executeRecaptcha} = useGoogleReCaptcha();
  const [token, setToken] = useState("");
  const [showContatoEnviadoSucesso, setShowContatoEnviadoSucesso] = useState(false);
  const location = useLocation();

  const handleReCaptchaVerify = useCallback(async () => {
    if (!executeRecaptcha) {
      // eslint-disable-next-line no-console
      console.log("Execute recaptcha not yet available");
      return;
    }

    if (showContactForm) {
      const result = await executeRecaptcha("homepage");
      setToken(result);
    }
  }, [executeRecaptcha, showContactForm]);

  useEffect(() => {
    if (showContactForm && enableRecaptcha) {
      handleReCaptchaVerify();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [handleReCaptchaVerify, showContactForm]);

  //@TODO: Move to smart component
  const handleSubmitContact = async (values: ContactMessageType) => {
    await handleReCaptchaVerify().then(() => {
      values.tokenRecaptcha = token;
    });
    await onFormSubmit(values as ContactMessageType).then(() => {
      setShowContatoEnviadoSucesso(true);
    });
  };

  return (
    <footer
      id="contato"
      style={{backgroundImage: `url(${footerBG})`}}
      className={`${!showContactForm && isMobile ? "hide" : ""} ${
        isBlackFriday && location.pathname === "/planos/inicio"
          ? "margin-top-0-footer"
          : ""
      } ${isBlackFriday && location.pathname === "/" ? "margin-top-0-footer" : ""}`}
    >
      <div className={`container ${!showContactForm && isMobile ? "hide" : ""}`}>
        <div className="footer-content">
          {showContactForm && (
            <div className="row">
              <div className="col-lg-6 col-md-12 col-sm-12">
                <div className="contact-form">
                  {showContatoEnviadoSucesso ? (
                    <div style={{padding: "45px"}}>
                      <div className="mb-2">
                        <img src={checkMark} width="50" alt="check-icon" />
                      </div>
                      <div className="mb-3">
                        <h2>Muito obrigado!</h2>
                      </div>
                      <div className="mb-3">
                        <p>Sua resposta foi submetida com sucesso.</p>
                        <p>Agradecemos pela sua colaboração :)</p>
                      </div>
                      <div>
                        <Button
                          className="main-button"
                          onClick={() => {
                            setShowContatoEnviadoSucesso(false);
                          }}
                        >
                          Enviar nova mensagem
                        </Button>
                      </div>
                    </div>
                  ) : (
                    <Formik
                      initialValues={initialValueContactForm}
                      validate={(values: ContactMessageType) => {
                        const errors: any = {};
                        if (!values.name) {
                          errors.name = "Campo Obrigatório";
                        }

                        if (!values.email) {
                          errors.email = "Campo Obrigatório";
                        } else if (
                          !/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i.test(values.email)
                        ) {
                          errors.email = "Email inválido";
                        }

                        if (!values.message) {
                          errors.message = "Campo obrigatório";
                        }

                        return errors;
                      }}
                      onSubmit={async (values, {setSubmitting}) => {
                        await handleSubmitContact(values);
                        setSubmitting(false);
                      }}
                    >
                      {({
                        errors,
                        touched,
                        handleSubmit,
                        values,
                        handleChange,
                        isSubmitting,
                      }) => (
                        <Form
                          id="contact"
                          action=""
                          onSubmit={handleSubmit}
                          method="post"
                        >
                          <div className="row">
                            <div className="col-md-6 col-sm-12">
                              <Form.Group controlId="validationFormikName">
                                <InputGroup hasValidation />
                                <Form.Control
                                  name="name"
                                  type="text"
                                  onChange={handleChange}
                                  placeholder="Nome Completo"
                                  style={{backgroundColor: "rgba(250, 250, 250, 0.3"}}
                                  isInvalid={!!errors.name}
                                  value={values.name}
                                />
                                <Form.Control.Feedback
                                  type="invalid"
                                  style={{textAlign: "left", marginTop: -25}}
                                >
                                  {touched.name && errors.name}
                                </Form.Control.Feedback>
                              </Form.Group>
                            </div>
                            <div className="col-md-6 col-sm-12">
                              <Form.Group controlId="validationFormikEmailContato">
                                <InputGroup hasValidation />
                                <Form.Control
                                  name="email"
                                  type="text"
                                  onChange={handleChange}
                                  placeholder="E-Mail"
                                  style={{backgroundColor: "rgba(250,250,250,0.3)"}}
                                  isInvalid={!!errors.email}
                                  value={values.email}
                                />
                                <Form.Control.Feedback
                                  type="invalid"
                                  style={{textAlign: "left", marginTop: -25}}
                                >
                                  {touched.email && errors.email}
                                </Form.Control.Feedback>
                              </Form.Group>
                            </div>
                            <div className="col-lg-12">
                              <Form.Group controlId="validationFormikMessage">
                                <InputGroup hasValidation />
                                <Form.Control
                                  as="textarea"
                                  name="message"
                                  rows={6}
                                  onChange={handleChange}
                                  placeholder="Mensagem"
                                  style={{backgroundColor: "rgba(250,250,250,0.3)"}}
                                  isInvalid={!!errors.message}
                                  value={values.message}
                                />
                                <Form.Control.Feedback
                                  type="invalid"
                                  style={{textAlign: "left", marginTop: -25}}
                                >
                                  {errors.message && touched.message && errors.message}
                                </Form.Control.Feedback>
                              </Form.Group>
                            </div>
                            <div className="col-lg-12">
                              <fieldset>
                                <button
                                  id="form-submit"
                                  type="submit"
                                  className="main-button"
                                  disabled={isSubmitting}
                                >
                                  Enviar mensagem
                                </button>
                              </fieldset>
                            </div>
                          </div>
                        </Form>
                      )}
                    </Formik>
                  )}
                </div>
              </div>
              <div className="right-content col-lg-6 col-md-12 col-sm-12">
                <h2>
                  Fale <em>Conosco</em>
                </h2>
                <p>
                  Nós estamos muito interessados no que você tem a dizer! Nos envie
                  dúvidas, sugestões, reclamações ou demais informações que tenha
                  interesse em compartilhar conosco através desse formulário. É fácil,
                  rápido e teremos o maior prazer em responder.
                  <br />
                  <br />
                  Você pode também nos seguir ou conversar conosco através das nossas
                  redes sociais abaixo.
                </p>
                <ul className="social">
                  <li>
                    <a
                      href="https://www.facebook.com/Adoo-102739498236060/"
                      target="_blank"
                      rel="noreferrer"
                    >
                      <i className="fa fa-facebook"></i>
                    </a>
                  </li>
                  <li>
                    <a
                      href="https://www.instagram.com/adoo_app/"
                      target="_blank"
                      rel="noreferrer"
                    >
                      <i className="fa fa-instagram"></i>
                    </a>
                  </li>
                </ul>
              </div>
            </div>
          )}
        </div>
        {showContactForm ? (
          <div className="row">
            <div className="col-lg-12">
              <div className="sub-footer"></div>
            </div>
          </div>
        ) : null}
      </div>
      <div className="footer-termos-uso">
        <div className="mb-2" style={{display: "flex", justifyContent: "center"}}>
          <a href="/termos-de-uso">Termos e Condições</a>
          <div className="ms-2 me-2">-</div>
          <a href="/politica-privacidade">Política de Privacidade</a>
        </div>
        <div style={{display: "flex", justifyContent: "center", alignItems: "center"}}>
          <div className="me-1">
            <img src={logoAdooBranco} width="120" alt="adoo" />
          </div>
          <div style={{display: "flex", paddingTop: "7px"}}>
            <div className="me-1">&copy; 2023</div>
            <div>Todos os direitos reservados</div>
          </div>
        </div>
      </div>
    </footer>
  );
}

export default Footer;
